// Экран 7 из ТЗ раздел 3.3, НАМЕРЕННО урезанный скоп — только отмена/возобновление автопродления
// (см. app/api/routes/miniapp/subscriptions.py::cancel_auto_renew/resume_auto_renew). Немедленная
// отмена с частичным возвратом средств не реализована — упирается в нерешённую политику возврата
// и отсутствие admin-панели для ручного процесса (см. docs/OPEN_QUESTIONS.md). Подписка при
// отключённом автопродлении остаётся полноценно активной до конца оплаченного периода — это не
// "отменённая" подписка в смысле статуса, только отметка "не продлевать".
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { ApiError, cancelAutoRenew, resumeAutoRenew } from "../api/client";
import { useSubscription } from "../hooks/useSubscription";

export function CancelScreen() {
  const { t } = useTranslation();
  const { subscription, loading, error, setSubscription, setError } = useSubscription();
  const [submitting, setSubmitting] = useState(false);

  const handleToggle = () => {
    if (!subscription) return;
    setSubmitting(true);
    setError(null);
    const action = subscription.auto_renew ? cancelAutoRenew : resumeAutoRenew;
    action()
      .then(setSubscription)
      .catch((err: unknown) => setError(err instanceof ApiError ? err.message : String(err)))
      .finally(() => setSubmitting(false));
  };

  return (
    <div>
      <h1>{t("cancel_title")}</h1>
      {error && <p role="alert">{error}</p>}
      {loading && <p>{t("loading")}</p>}
      {!loading && subscription === null && <p>{t("subscription_none")}</p>}
      {subscription && (
        <div>
          <p>
            {t("cancel_auto_renew_status")}:{" "}
            <strong>
              {subscription.auto_renew ? t("cancel_auto_renew_on") : t("cancel_auto_renew_off")}
            </strong>
          </p>
          {!subscription.auto_renew && <p>{t("cancel_note_still_active")}</p>}
          <button type="button" onClick={handleToggle} disabled={submitting}>
            {submitting
              ? t("loading")
              : subscription.auto_renew
                ? t("cancel_action_cancel")
                : t("cancel_action_resume")}
          </button>
        </div>
      )}
    </div>
  );
}
